import React, { useMemo } from 'react';
import {
  Box,
  Grid,
  Link,
  Paper,
  Typography,
  makeStyles,
} from '@material-ui/core';
import mainColors from '../../../themes/main-colors';
import EnergySavingsIcon from './EnergySavingsIcon';
import UserIcon from './UserIcon';
import { useTranslation } from '../../../hooks/useTranslation';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: mainColors.white,
    color: mainColors.noirBlur,
    borderRadius: 4,
    padding: theme.spacing(3),
    width: '100%',
    boxSizing: 'border-box',
  },
  section: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    flexDirection: 'column',
  },
  titleBlock: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  },
  title: {
    fontSize: 20,
    fontWeight: 700,
    marginBottom: theme.spacing(1),
    fontFamily: 'Forma-DJR-Display',
  },
  subtitle: {
    fontSize: 16,
    lineHeight: '24px',
    fontWeight: 700,
    marginBottom: theme.spacing(2),
  },
  description: {
    fontSize: 16,
    lineHeight: '22px',
    marginBottom: theme.spacing(2),
    /* maxWidth: 360, */
  },
  cta: {
    fontSize: 16,
    lineHeight: '24px',
    fontWeight: 700,
    color: mainColors.sparkBlue,
    textDecoration: 'underline',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  image: {
    width: 56,
    height: 56,
    objectFit: 'contain',
    flexShrink: 0,
    marginTop: theme.spacing(0.5),
  },
  dividerWrap: {
    display: 'flex',
    justifyContent: 'center',
  },
  divider: {
    width: 1,
    backgroundColor: mainColors.lightGray1,
    minHeight: 160,
  },
  leftColumn: {
    paddingRight: theme.spacing(2),
  },
  rightColumn: {
    paddingLeft: theme.spacing(2),
    borderLeft: `1px solid ${mainColors.lightGray1}`,
    borderTop: 'none',
  },
  [theme.breakpoints.down('sm')]: {
    root: {
      padding: theme.spacing(2),
    },
    leftColumn: {
      paddingRight: 0,
      marginBottom: theme.spacing(1),
    },
    rightColumn: {
      paddingLeft: 0,
      marginTop: theme.spacing(1),
      borderLeft: 'none',
      borderTop: `1px solid ${mainColors.lightGray1}`,
      paddingTop: theme.spacing(3),
    },
    dividerWrap: {
      display: 'none',
    },
    section: {
      gap: theme.spacing(1.5),
    },
    image: {
      width: 48,
      height: 48,
    },
  },
}));

const BusinessProgramsCard = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  const content = useMemo(() => {
    return {
      left: {
        title: t('ENERGY_SAVING_CHECKUP_TITLE'),
        subtitle: t('ENERGY_SAVING_CHECKUP_SUBTEXT'),
        description: t('ENERGY_SAVING_CHECKUP_DESC'),
        ctaText: t('ENERGY_SAVING_CHECKUP_CTA'),
        ctaHref: t('ENERGY_SAVING_CHECKUP_CTA_LINK'),
        icon: <EnergySavingsIcon />,
      },
      right: {
        title: t('TELL_US_ABOUT_BUSINESS_TITLE'),
        subtitle: t('TELL_US_ABOUT_BUSINESS_SUBTEXT'),
        description: t('TELL_US_ABOUT_BUSINESS_DESC'),
        ctaText: t('TELL_US_ABOUT_BUSINESS_CTA'),
        ctaHref: t('TELL_US_ABOUT_BUSINESS_CTA_LINK'),
        icon: <UserIcon />,
      },
    };
  }, []);

  return (
    <Paper>
      <Box className={classes.root}>
        <Grid container alignItems="stretch">
          {/* Left Section */}
          <Grid item xs={12} md={12} className={classes.leftColumn}>
            <Box className={classes.section}>
              <Box className={classes.titleBlock}>
                <Box>
                  <Typography className={classes.title}>
                    {content.left.title}
                  </Typography>

                  <Typography className={classes.subtitle}>
                    {content.left.subtitle}
                  </Typography>
                </Box>
                <Box>{content.left.icon}</Box>
              </Box>

              <Typography className={classes.description}>
                {content.left.description}
              </Typography>

              <Link href={content.left.ctaHref} className={classes.cta}>
                {content.left.ctaText}
              </Link>
            </Box>
          </Grid>

          {/* Right Section */}
          {/* <Grid item xs={12} md={6} className={classes.rightColumn}>
            <Box className={classes.section}>
              <Box className={classes.titleBlock}>
                <Box>
                  <Typography className={classes.title}>
                    {content.right.title}
                  </Typography>

                  <Typography className={classes.subtitle}>
                    {content.right.subtitle}
                  </Typography>
                </Box>
                <Box>{content.right.icon}</Box>
              </Box>

              <Typography className={classes.description}>
                {content.right.description}
              </Typography>

              <Link href={content.right.ctaHref} className={classes.cta}>
                {content.right.ctaText}
              </Link>
            </Box>
          </Grid> */}
        </Grid>
      </Box>
    </Paper>
  );
};

export default BusinessProgramsCard;
